export const IWelcomeBannerProperties = Object.freeze({
  title: "title",
  picture: "picture",
  matchedOffers: "matched_offers",
});

export class WelcomeBannerPropertiesModel {
  constructor(data = {}) {
    this[IWelcomeBannerProperties.title] = data[IWelcomeBannerProperties.title];
    this[IWelcomeBannerProperties.matchedOffers] = data[IWelcomeBannerProperties.matchedOffers];
    this[IWelcomeBannerProperties.picture] = data[IWelcomeBannerProperties.picture];
  }

  getTitle() {
    return this[IWelcomeBannerProperties.title];
  }

  getMatchedOffers() {
    return this[IWelcomeBannerProperties.matchedOffers];
  }

  getPicture() {
    return this[IWelcomeBannerProperties.picture];
  }
}
